export default __webpack_public_path__ + "static/media/room2-MULTIPLY.d75d2047.png";